import $ from "jquery";
import videojs from "video.js";
import Storage from "@bd-utils/storage";
import bdjs from "@bd-core/bdjs";
import { getCurrentPageId } from "@bd-stores/user-progress";

export default class IntroVideoRoom {
    constructor() {
        this.$app = $(".app");
        this.$introVideo = $(".videobox.intro-video");
        this.videoIntro = null;

        this.$popup = $(".js-briefing");
        this.$startBtn = ".js-start-challenge";
        this.$replayIntro = $(".js-replay-intro");
    }

    initForRoom(room, videoId = null, onVideoEnd = null) {
        const roomID = getCurrentPageId();
        const hasSeen = this._getHasSeen(roomID);
        if (hasSeen) {
            if (onVideoEnd && typeof onVideoEnd === "function") {
                onVideoEnd();
            }
        } else {
            this.$popup.addClass("is-open");
        }

        const $introVideo = $(".videobox.intro-video");
        if ($introVideo.length === 0) {
            this.$popup.off("click", this.$startBtn);
            this.$popup.on("click", this.$startBtn, () => {
                this._setHasSeen(roomID);
                this.$popup.removeClass("is-open");
                if (onVideoEnd && typeof onVideoEnd === "function") {
                    onVideoEnd();
                }
            });
            return;
        }

        // If videoId is provided, use it, otherwise construct from room
        const finalVideoId = videoId || `intro-video-${room}`;

        this.videoIntro = videojs(finalVideoId, {
            controls: true,
            autoplay: false,
            preload: "auto",
        });

        this.videoIntro.on("loadeddata", () => {
            const tracks = this.videoIntro.textTracks();

            const track = tracks[0];
            if (!track) return;

            const cues = track.cues;
            if (cues.length === 0) return;

            const applyCueStyles = () => {
                const activeCueElements = this.videoIntro
                    .el()
                    .querySelectorAll(".vjs-text-track-cue");
                activeCueElements.forEach((el) => {
                    const htmlEl = /** @type {HTMLElement} */ (el);
                    const innerDiv = htmlEl.querySelector("div");
                    if (innerDiv) {
                        innerDiv.style.background = "transparent";
                        innerDiv.style.color = "#ffffff";
                        innerDiv.style.textShadow =
                            "0px 0px 12px rgba(0, 0, 0, 0.5), 0px 0px 12px rgba(0, 0, 0, 0.5), 0px 0px 12px rgba(0, 0, 0, 0.5), 0px 0px 12px rgba(0, 0, 0, 0.5), 0 0 12px rgba(0, 0, 0, 0.5)";
                    }
                });
            };

            let timeupdateTimeout = null;
            this.videoIntro.on("timeupdate", () => {
                if (timeupdateTimeout) {
                    clearTimeout(timeupdateTimeout);
                }
                timeupdateTimeout = setTimeout(() => {
                    applyCueStyles();
                }, 100);
            });

            setTimeout(applyCueStyles, 100);

            for (let i = 0; i < cues.length; i++) {
                const cue = cues[i];
                cue.onenter = () => {
                    setTimeout(applyCueStyles, 0);
                };
            }

            this.videoIntro.on("texttrackchange", () => {
                applyCueStyles();
            });

            const textTrackDisplay = this.videoIntro
                .el()
                .querySelector(".vjs-text-track-display");
            if (textTrackDisplay) {
                const observer = new MutationObserver(() => {
                    applyCueStyles();
                });
                observer.observe(textTrackDisplay, {
                    childList: true,
                    subtree: true,
                });
            }
        });

        this.videoIntro.on("ended", () => {
            this._setHasSeen(roomID);
            $introVideo.removeClass("is-open");
            this.$app.removeAttr("style");

            if (onVideoEnd && typeof onVideoEnd === "function") {
                onVideoEnd();
            }
        });

        this.videoIntro.on("error", () => {
            $introVideo.removeClass("is-open");
            this.$app.removeAttr("style");

            if (onVideoEnd && typeof onVideoEnd === "function") {
                onVideoEnd();
            }
        });

        this.$popup.off("click", this.$startBtn);
        this.$popup.on("click", this.$startBtn, () => {
            this.showVideo();
            this.startVideo();
        });
        this.$replayIntro.off("click");
        this.$replayIntro.on("click", () => {
            this.showVideo();
            this.startVideo();
        });

        return this.videoIntro;
    }

    _setHasSeen(roomId) {
        let states = Storage.get("states", {});
        if (!states?.intro_videos) states.intro_videos = [];

        if (!states.intro_videos.includes(roomId)) {
            states.intro_videos.push(roomId);
            return Storage.set("states", states);
        }

        return false;
    }

    _getHasSeen(roomId) {
        let states = Storage.get("states", {});
        return states?.intro_videos && states.intro_videos.includes(roomId);
    }

    maybeResetState(roomId) {
        if (!this._getHasSeen(roomId)) return false;

        let states = Storage.get("states", {});
        if (!states?.intro_videos) states.intro_videos = [];

        const initialLength = states.intro_videos.length;
        const intro_videos = bdjs.removeItemArray(states.intro_videos, roomId);

        if (intro_videos.length !== initialLength) {
            states.intro_videos = intro_videos;
            return Storage.set("states", states);
        }

        return false;
    }

    startVideo() {
        if (this.videoIntro) {
            this.videoIntro.play();
        }
    }

    showVideo() {
        this.$introVideo.addClass("is-open");
        this.$popup.removeClass("is-open");
        this.$app.css({ position: "relative", zIndex: 3 });
    }

    cleanup() {
        if (this.videoIntro) {
            this.videoIntro.dispose();
            this.videoIntro = null;
        }
        this.$introVideo.removeClass("is-open");
        this.$app.removeAttr("style");

        this.$popup.off("click", this.$startBtn);
    }
}
